import React, { useState, useRef } from 'react';
import { useVisitorTracking } from '../hooks/useVisitorTracking';
import { API_CONFIG } from '../config/apiConfig';

const Contact = () => {
  const { ref } = useVisitorTracking('contact', {
    threshold: 0.5,
    minDuration: 3
  });

  // Form submission state
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Form refs
  const formRef = useRef(null);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    setSubmitError('');
    setSubmitMessage('');

    const formData = new FormData(formRef.current);

    try {
      const response = await fetch('https://formspree.io/f/mblgroaz', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setSubmitMessage('✅ Message sent successfully! Thank you for contacting us.');

        // Save to localStorage for Admin Dashboard
        try {
          const newSubmission = {
            id: Date.now().toString(),
            timestamp: new Date().toISOString(),
            name: formData.get('name'),
            email: formData.get('email'),
            service: formData.get('services'),
            message: formData.get('message'),
            linkedin: formData.get('linkedin') || ''
          };

          const existingSubmissions = JSON.parse(localStorage.getItem('contact_submissions') || '[]');
          const updatedSubmissions = [newSubmission, ...existingSubmissions];
          localStorage.setItem('contact_submissions', JSON.stringify(updatedSubmissions));

          // Trigger a storage event for other tabs/components to pick up changes immediately
        window.dispatchEvent(new Event('storage'));
        
        // Trigger specific event for Header component to disable the contact button
        window.dispatchEvent(new Event('contactMessageSent'));
        
        console.log('✅ Saved submission to localStorage:', newSubmission);
        } catch (err) {
          console.error('Error saving to localStorage:', err);
        }

        // Submit to Backend (New Implementation with Geo)
        try {
          const backendData = {
            name: formData.get('name'),
            email: formData.get('email'),
            services: formData.get('services'),
            message: formData.get('message'),
            linkedin: formData.get('linkedin') || ''
          };

          fetch(API_CONFIG.ENDPOINTS.CONTACT_SUBMIT, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(backendData)
          }).then(res => res.json())
            .then(data => console.log('✅ Backend submission success:', data))
            .catch(err => console.error('❌ Backend submission failed:', err));

        } catch (err) {
          console.error('Error submitting to backend:', err);
        }

        // Reset form
        formRef.current.reset();
      } else {
        setSubmitError('❌ Failed to send message. Please try again.');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitError('❌ Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  }


  return (
    <section
      id="contact"
      className="contact"
      ref={ref}
      style={{
        backgroundImage:
          "linear-gradient(135deg, rgba(75,0,130,0.3) 0%, rgba(255,45,85,0.2) 100%), url('" +
          process.env.PUBLIC_URL +
          "/nasa_Q1 nb.png')",
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="contact-overlay">
        <h2>LET'S CREATE TOGETHER</h2>
        <form ref={formRef} action="https://formspree.io/f/mblgroaz" method="POST" onSubmit={handleSubmit}>
          <label htmlFor="name">YOUR NAME</label>
          <input type="text" id="name" name="name" placeholder="NAME" required />

          <label htmlFor="email">YOUR EMAIL</label>
          <input type="email" id="email" name="email" placeholder="EMAIL" required />

          {submitMessage && (
            <div className="verification-message success">
              {submitMessage}
            </div>
          )}

          {submitError && (
            <div className="verification-message error">
              {submitError}
            </div>
          )}

          <label htmlFor="services">WHAT SERVICES ARE YOU LOOKING FOR?</label>
          <input type="text" id="services" name="services" placeholder="Web Design, Graphic design..." required />

          <label htmlFor="message">YOUR MESSAGE</label>
          <textarea id="message" name="message" placeholder="YOUR MESSAGE" required></textarea>

          <label htmlFor="linkedin">Your LinkedIn <span style={{ color: 'green' }}>(Optional)</span></label>
          <input type="url" id="linkedin" name="linkedin" placeholder="https://www.linkedin.com/in/your-profile" />

          <button
            type="submit"
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'SENDING...' : 'SEND'}
          </button>
        </form>
      </div>

    </section>
  );
};

export default Contact;